import React, { useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import { getParameterByName } from '../../components/ControlPanel/ControlPanel';
import BackendService from '../../services/BackendService';

const useAuthorizedPractitioner = () => {
  const history = useHistory();

  const token = getParameterByName('token') as string;
  const sessionId = getParameterByName('sessionUUID') as string;
  const treatmentId = getParameterByName('treatmentUUID') as string;

  const checkAuthToken = async () => {
    try {
      const response = await BackendService.checkIfPractitionerHasValidToken(token, sessionId, treatmentId);
      const result = await response.json();
      if (result && result.error) {
        history.push('/access-denied');
        return;
      }
      if (result && !result.length) {
        history.push('/invalid-session');
        return;
      }
    } catch (e) {
      history.push('/access-denied');
      return;
    }
  };

  useEffect(() => {
    if (!token) {
      history.push('/access-denied');
      return;
    }

    if (!sessionId || !treatmentId) {
      history.push('/invalid-session');
      return;
    }

    checkAuthToken();
  }, [history, token, sessionId, treatmentId]);

  return null;
};

export default useAuthorizedPractitioner;
